export default __webpack_public_path__ + "static/media/c2.d2828361.png";